/**
 * @overview Layout mixins
 */

import { css } from 'styled-components';
import { settings } from '../settings/index';

const {
  colors: { color },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, desktopDown },
  sizing: { spacingsize },
} = settings;

export const centered = css`
  margin-right: auto;
  margin-left: auto;
`;

export const centeredContent = css`
  ${centered}
  max-width: 66%;
  text-align: center;

  @media ${tabletLandscapeDown} {
    max-width: 80%;
  }

  @media ${tabletPortraitDown} {
    max-width: 90%;
  }
`;

export const container = css`
  ${centered}
`;

export const mobileGutters = css`
  @media ${tabletPortraitDown} {
    padding-right: ${spacingsize(5)};
    padding-left: ${spacingsize(5)};
  }
`;

export const desktopGutters = css`
  padding-right: ${spacingsize(10)};
  padding-left: ${spacingsize(10)};
`;

export const gutters = css`
  ${mobileGutters}
  ${desktopGutters}
`;

export const pageSectionInner = css`
  ${container}
  /* stylelint-disable comment-empty-line-before */
  ${(props) => (!props.removeGutters || props.removeGutters === false) && css`
    ${gutters}
  `}
  /* stylelint-enable */

  padding-top: ${spacingsize(10)};
  padding-bottom: ${spacingsize(10)};

  @media ${tabletPortraitDown} {
    padding-top: ${spacingsize(8)};
    padding-bottom: ${spacingsize(8)};
  }

  @media ${mobileDown} {
    padding-top: ${spacingsize(8)};
    padding-bottom: ${spacingsize(8)};
  }

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.isCenteredSection) && css`
    width: 70%;

    @media ${desktopDown} {
      width: 75%;
    }

    @media ${tabletLandscapeDown} {
      width: 80%;
    }

    @media ${mobileDown} {
      width: 90%;
    }
  `}

  ${(props) => (props.sectionVerticalPaddingSize && props.sectionVerticalPaddingSize === `none`) && css`
    padding-top: 0;
    padding-bottom: 0;

    @media ${tabletPortraitDown} {
      padding-top: 0;
      padding-bottom: 0;
    }
  `}

  ${(props) => (props.sectionVerticalPaddingSize && props.sectionVerticalPaddingSize === `x-large`) && css`
    padding-top: 8rem;
    padding-bottom: 8rem;

    @media ${tabletPortraitDown} {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }
  `}

  ${(props) => (props.sectionVerticalPaddingSize && props.sectionVerticalPaddingSize === `large`) && css`
    padding-top: ${spacingsize(13)};
    padding-bottom: ${spacingsize(13)};

    @media ${tabletPortraitDown} {
      padding-top: ${spacingsize(11)};
      padding-bottom: ${spacingsize(11)};
    }
  `}

  ${(props) => (props.sectionVerticalPaddingSize && props.sectionVerticalPaddingSize === `medium`) && css`
    padding-top: ${spacingsize(10)};
    padding-bottom: ${spacingsize(10)};

    @media ${tabletPortraitDown} {
      padding-top: ${spacingsize(8)};
      padding-bottom: ${spacingsize(8)};
    }
  `}
  ${(props) => (props.sectionVerticalPaddingSize && props.sectionVerticalPaddingSize === `small`) && css`
    padding-top: ${spacingsize(8)};
    padding-bottom: ${spacingsize(8)};

    @media ${tabletPortraitDown} {
      padding-top: ${spacingsize(6)};
      padding-bottom: ${spacingsize(6)};
    }
  `}
  /* stylelint-enable */
`;

export const pageSection = css`
  width: 100%;

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}
  /* stylelint-enable */
`;

export const fullContainerBackgroundImage = css`
  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundImageUrl) && css`
    background: url("${props.backgroundImageUrl}") no-repeat center center;
    background-size: cover;
  `}
  /* stylelint-enable */
`;
